import React, { useEffect, useState } from "react";
import { Alert, Link } from "@mui/material";
import axios from "axios";
import { host } from "../libs/webRTC";
import { useUser } from "../context/UserContext";

export default function DuplicateVideos({ token }) {
    const { user } = useUser();
    const [duplicates, setDuplicates] = useState([]);
    const [failed, setFailed] = useState(false);

    const canView = Boolean(user && (
        user.isAdmin ||
        user.routes === true ||
        (
            Array.isArray(user.routes) &&
            user.routes.includes("/table/other")
        )
    ));

    useEffect(() => {
        if (!canView) return;

        let active = true;

        setDuplicates([]);
        setFailed(false);

        axios.get(`${host}/upload/session/${token}/duplicates`)
            .then(({ data }) => {
                if (!Array.isArray(data?.duplicates)) {
                    throw new Error("Некорректный ответ сервера");
                }

                if (active) {
                    setDuplicates(data.duplicates);
                }
            })
            .catch(() => {
                if (active) {
                    setFailed(true);
                }
            });

        return () => {
            active = false;
        };
    }, [token, canView]);

    if (!canView) return null;

    if (failed) {
        return (
            <Alert severity="error" sx={{ m: 2 }}>
                Не удалось проверить одинаковые видео.
            </Alert>
        );
    }

    if (duplicates.length === 0) return null;

    return (
        <Alert severity="warning" sx={{ m: 2 }}>
            Обнаружены одинаковые видео в других сессиях:
            <ul>
                {duplicates.map(sessionId => (
                    <li key={sessionId}>
                        <Link
                            href={`/teach/${sessionId}`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Сессия {sessionId}
                        </Link>
                    </li>
                ))}
            </ul>
        </Alert>
    );
}